var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column flex-grow-1" },
    [
      _vm.items.length === 0
        ? _c(
            "b-card",
            {
              staticClass: "flex-grow-1 text-center",
              attrs: {
                "body-class": "d-flex align-items-center justify-content-center"
              }
            },
            [_c("span", [_vm._v("Работников на смене не найдено")])]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.items.length > 0
        ? _c(
            "div",
            { staticClass: "grid-items grid-3 grid flex-grow-1" },
            _vm._l(_vm.paginatedData, function(item) {
              return _c(
                "b-card",
                { key: item.id },
                [
                  _vm._t("item", [_vm._v("\n        Пустой слот\n      ")], {
                    item: item
                  })
                ],
                2
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-card",
        {
          staticClass: "controls",
          attrs: {
            "no-body": "",
            "header-class":
              "controls-in-slot d-flex justify-content-between align-items-center w-100"
          }
        },
        [
          _c("template", { slot: "header" }, [
            _c(
              "div",
              { staticClass: "switch-page d-flex align-items-center" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "mr-2",
                    attrs: { disabled: _vm.currentPage === 0 },
                    on: { click: _vm.prevPage }
                  },
                  [_vm._v("\n          Предыдущая страница\n        ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "pageInfo" }, [
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v(
                      "Страница " +
                        _vm._s(_vm.currentPageNum) +
                        " из (" +
                        _vm._s(_vm.pageCount) +
                        ")"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "ml-2",
                    attrs: { disabled: _vm.currentPage > _vm.pageCount - 2 },
                    on: { click: _vm.nextPage }
                  },
                  [_vm._v("\n          Следующая страница\n        ")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "other-controls ml-2" },
              [_vm._t("controls")],
              2
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-347485bf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347485bf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TableViewWithPagination.vue
// module id = null
// module chunks = 